/**
 * Maps raw auth error messages to stable, localized copy keys. Raw provider
 * messages never reach the UI: they are technical, English-only, and
 * occasionally leak account-existence hints in the wrong direction. The
 * returned string is an i18n key under `login.errors.*`.
 *
 * Pure function so the mapping is unit-testable.
 */
export function classifySignupError(message: string | null | undefined): string {
  const m = (message ?? "").toLowerCase();
  if (!m) return "login.errors.generic";
  if (m.includes("already registered") || m.includes("already been registered") || m.includes("user already exists"))
    return "login.errors.alreadyRegistered";
  if (m.includes("easy to guess") || m.includes("known to be weak") || m.includes("breached"))
    return "login.errors.passwordBreached";
  if (m.includes("not allowed") || m.includes("cannot receive email")) return "login.errors.emailNotAllowed";
  if (m.includes("password") && (m.includes("at least") || m.includes("weak") || m.includes("should be")))
    return "login.errors.weakPassword";
  if (m.includes("rate limit") || m.includes("too many requests") || m.includes("over_email_send_rate_limit"))
    return "login.errors.rateLimited";
  if (m.includes("invalid") && m.includes("email")) return "login.errors.invalidEmail";
  if (m.includes("invalid login credentials")) return "login.errors.invalidCredentials";
  if (m.includes("email not confirmed")) return "login.errors.emailNotConfirmed";
  if (m.includes("network") || m.includes("fetch") || m.includes("failed to fetch")) return "login.errors.network";
  return "login.errors.generic";
}
